import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { accountsApi } from '../lib/api';

export function useAccounts() {
  return useQuery({
    queryKey: ['accounts'],
    queryFn: async () => {
      const res = await accountsApi.list();
      return (res?.accounts ?? []) as Array<{
        id: string;
        display_name: string;
        email: string;
        is_active: boolean;
        sync_status: string;
        last_sync_at: string | null;
        supports_idle: boolean | null;
        default_for_send: boolean;
      }>;
    },
  });
}

export function useCreateAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: unknown) => accountsApi.create(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['accounts'] }),
  });
}

export function useTestAccount() {
  return useMutation({
    mutationFn: (input: unknown) => accountsApi.test(input),
  });
}
